<template>
  <div class="con-wrap" style="background-color:#fff;margin-top:0">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div class="query-box">
         <el-form-item class="r-20" prop="personnelName">
          <el-input
            v-model="queryForm.personnelName"
            @keyup.enter.native="query"
            placeholder="车辆绑定人"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="userAccount">
          <el-input
            v-model="queryForm.userAccount"
            @keyup.enter.native="query"
            placeholder="车主账号"
          ></el-input>
        </el-form-item>
         <el-form-item class="r-20" prop="plateNum">
          <el-input
            v-model="queryForm.plateNum"
            @keyup.enter.native="query"
            placeholder="车牌号"
          ></el-input>
        </el-form-item>

        <el-form-item class="date-input">
          <date-picker
            :startTime="queryForm.startTime"
            :endTime="queryForm.endTime"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="hasPerm('statistics:data:dynamo')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('statistics:data:dynamo')" @click="reset"
            >取消</el-button
          >
        </el-form-item>
      </div>

      <div style="margin-bottom:20px">
        <el-button
          v-if="hasPerm('statistics:data:dynamo:export')"
          type="primary"
          @click="exportData"
          >数据导出</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
    >
      <el-table-column
        align="center"
        type="index"
        label="序号"
        width="55"
      ></el-table-column>
      <el-table-column prop="name" label="车辆绑定人"></el-table-column>
      <el-table-column
        prop="account"
        label="车主账号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="发电开始时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="发电结束时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="capacity"
        label="发电量（kW·h）"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="duration"
        label="发电时长"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oil"
        label="发电油耗（L）"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="stationName"
        label="站址名称"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue"
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      queryForm: {
        personnelName:"",
        plateNum:'',
        deptId: "",
        userAccount: "",
        startTime: "",
        endTime: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
    }
  },
  created() {
    this.getRecordList()
  },
  methods: {
    changeStart(val) {
      console.log(val + "---")
      this.queryForm.startTime = val
    },
    changeEnd(val) {
      this.queryForm.endTime = val
    },
    exportStart(val) {
      this.exportStartTime = val
    },
    exportEnd(val) {
      this.exportEndTime = val
    },
    async getRecordList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        personnelName: this.queryForm.personnelName,
        plateNum: this.queryForm.plateNum,
        userAccount: this.queryForm.userAccount,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
      }
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dynamo",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    exportData() {
      let _this = this
      let url = ""
      _this
        .$confirm("确定导出当前查询条件下的数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          url =
            "/api/v2/statistics/data/dynamo/export?startTime=" +
            _this.queryForm.startTime +
            "&endTime=" +
            _this.queryForm.endTime +
            "&userAccount=" +
            _this.queryForm.userAccount

          window.location.href = url
        })
    },
    query() {
      this.currentPage = 1
      this.getRecordList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.queryForm.startTime = ""
      this.queryForm.endTime = ""
      this.currentPage = 1
      this.getRecordList()
    },
    //选择数据变化监控
    handleClickTableRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.getRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.query-box /deep/ .el-date-editor {
  width: 100% !important;
}
.date-input /deep/ {
  .el-form-item__content {
    width: 620px;
    .el-col-1 {
      margin-left: 18px !important;
    }
  }
}
.con-wrap /deep/ .mini-dialog .el-form-item__label {
  width: 110px;
  margin-left: 0;
}
</style>
